export default __webpack_public_path__ + "static/media/Roadmap.8a0db882.png";